import classNames from 'classnames';
import { toast, ToastOptions } from 'react-toastify';
import styled from 'styled-components';

import { Error } from 'components/Icons/Error';

const ErrorToast = styled.div`
  display: flex;
  line-height: 16px;
  flex-direction: column;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  span {
    word-break: break-word;
  }
`;

const ErrorTitle = styled.div`
  display: flex;
  color: #cf4845;
  font-weight: 600;
  align-items: center;
  margin-bottom: 10px;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }
`;

export const showError = (message: string, options: ToastOptions = {}) => {
  if (options.autoClose === false) {
    options.className = classNames(options.className || '', 'toast-with-close');
  }

  if (!message) return null;

  return toast.error(
    <ErrorToast>
      <ErrorTitle>
        <Error size={16} />
        ERROR
      </ErrorTitle>
      {message}
    </ErrorToast>,
    options
  );
};
